module.exports = __webpack_public_path__ + "static/media/preach.43a746ab.jpg";